import { IStateProvider } from 'angular-ui-router';

import { SdcStateBuilder } from './sdc-state-builder.service';

RegentsPlanningRouteConfig.$inject = ['$stateProvider'];

const SDC_KEY = 'regents-planning';

export function RegentsPlanningRouteConfig($stateProvider: IStateProvider) {
  const regentsPlanningGridState = SdcStateBuilder.buildGridState(SDC_KEY);
  const regentsPlanningWizardState = SdcStateBuilder.buildRegentsPlanningWizardState(SDC_KEY);
  const regentsPlanningProfileState = SdcStateBuilder.buildProfileState(SDC_KEY);

  $stateProvider

    .state(`main.school.new-sdc.${SDC_KEY}`, {
      abstract: true,
      url: `/${SDC_KEY}`,
      template: `
      <sdc-root
      current-user="$resolve.currentUser"
      current-state="$resolve.currentState">
      </sdc-root>
      `,
    })

    .state(`main.school.new-sdc.${SDC_KEY}.grid`, regentsPlanningGridState)
    .state(`main.school.new-sdc.${SDC_KEY}.wizard`, regentsPlanningWizardState)
    .state(`main.school.new-sdc.${SDC_KEY}.profile`, regentsPlanningProfileState);
}
